import React from "react";
import { Section, SectionHeading } from "./Primitives";
import { Reveal } from "./Primitives";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "../ui/accordion";
import { useSiteContent } from "../../context/SiteContentContext";
import { RowSkeleton } from "./Skeletons";

export const FAQ = () => {
  const { faqs, loading } = useSiteContent();
  return (
    <Section id="faq">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4 lg:sticky lg:top-28 lg:self-start">
          <SectionHeading
            overline="Common questions"
            title="Answers before you ask."
            intro="Everything buyers usually want to know before a first call."
          />
        </div>

        <div className="lg:col-span-8">
          <Reveal>
            {loading ? (
              <div>{Array.from({ length: 5 }).map((_, i) => <RowSkeleton key={i} />)}</div>
            ) : (
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((item, i) => {
                const f = item.data;
                return (
                <AccordionItem
                  key={item.id}
                  value={`item-${i}`}
                  className="border-t border-white/10 border-b-0 last:border-b"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left font-heading text-lg md:text-xl font-medium text-white hover:text-brand hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base leading-relaxed text-muted-foreground pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
                );
              })}
            </Accordion>
            )}
          </Reveal>
        </div>
      </div>
    </Section>
  );
};

export default FAQ;
